/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_7dInputs */

const vi_warehouse_sales_preset_7d = /** @type {(inputs: Warehouse_Sales_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 ngày`)
};

/**

* @param {Warehouse_Sales_Preset_7dInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_7d = /** @type {((inputs?: Warehouse_Sales_Preset_7dInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_7dInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_7d(inputs)
});